module.exports = __webpack_public_path__ + "static/media/MoonElf.7374216d.png";